const state = {
  activeTab: 'active',
  contentWizardActiveTab: 'standard',
  monthsFilter: 3,
  completedByFilter: {},
};

const getters = {
  activeTab: ({activeTab}) => activeTab,
  contentWizardActiveTab: ({contentWizardActiveTab}) => contentWizardActiveTab,
  completedByFilter: ({completedByFilter}) => completedByFilter,
  monthsFilter: ({monthsFilter}) => monthsFilter,
};

const actions = {
  setActiveTab: ({commit}, tab) => commit('setActiveTab', tab),
  setContentWizardActiveTab: ({commit}, tab) => commit('setContentWizardActiveTab', tab),
  setCompletedByFilter: ({commit}, completedByFilter) => commit('setCompletedByFilter', completedByFilter),
  toggleCompletedByFilter: ({commit}, name) => commit('toggleCompletedByFilter', name),
  setMonthsFilter: ({commit}, monthsFilter) => commit('setMonthsFilter', monthsFilter),
};

const mutations = {
  setActiveTab(state, tab) {
    state.activeTab = tab;
  },
  setContentWizardActiveTab(state, tab) {
    state.contentWizardActiveTab = tab;
  },
  setCompletedByFilter(state, completedByFilter) {
    state.completedByFilter = completedByFilter;
  },
  toggleCompletedByFilter(state, name) {
    const index = state.completedByFilter.findIndex((filter) =>filter.name === name);
    state.completedByFilter[index].active = !state.completedByFilter[index].active;
  },
  setMonthsFilter(state, monthsFilter) {
    state.monthsFilter = monthsFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
